import FormData from 'form-data'
import {
  GetMeParams,
  GetMeResponse,
  LoginRequestParams,
  LoginResponse,
  RegisterRequestParams,
  RegisterResponse,
  PutProfileImageParams,
} from '../types'
import { instance } from './index'

export const signup = (params: RegisterRequestParams): Promise<RegisterResponse> => {
  return instance.post('/doctors', params)
}

export const signin = ({ username, password }: LoginRequestParams): Promise<LoginResponse> => {
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  return instance.post(`/login/access-token/`, formData).then((res) => res.data)
}

export const get = ({ accessToken }: GetMeParams): Promise<GetMeResponse> => {
  if (accessToken) {
    return instance
      .get(`/login/me/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => res.data)
  }
  return instance.get(`/login/me/`).then((res) => res.data)
}

export const putProfileImage = ({ file }: PutProfileImageParams) => {
  return instance
    .put(`/login/me/profile-image/`, file, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((res) => res.data)
}
